import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetRoomCategories } from "../../../../api/ipd/roomCategoryAPI";
import { GetRoomById, UpdateRoom } from "../../../../api/ipd/roomAPI";
import { GetNursingStations } from "../../../../api/ipd/nursingStationAPI";
import {
  GetMedicineCompositionById,
  UpdateMedicineComposition
} from "../../../../api/medicalStore/master/medicineCompositionAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Composition name is required")
});

const EditMedicineComposition = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetMedicineCompositionById(id); // Make sure login function returns token

      if (response.success) {
        Object.keys(response.data).forEach(key => {
          setValue(key, response.data[key]);
        });
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      if (id) {
        fetchData();
      }
    },
    [id, setValue]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateMedicineComposition(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Medical Store" title="Edit Medicine Composition" />

      <div className="container-fluid">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Edit Medicine Composition</h5>

            <Link
              to={`${process.env
                .PUBLIC_URL}/medical-store/master/medicine-composition/list`}
            >
              <button className="btn btn-primary" id="list">
                List Composition
              </button>
              <UncontrolledTooltip target="list">
                List Composition
              </UncontrolledTooltip>
            </Link>
          </div>

          <form
            ref={formRef}
            className="form theme-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="card-body">
              <div className="row">
                {/* Composition Name */}
                <div className="col-6">
                  <div className="form-group">
                    <label>Composition Name</label>
                    <input
                      className="form-control"
                      placeholder="Enter composition name"
                      {...register("name")}
                    />
                    {errors.name &&
                      <p className="text-danger">
                        {errors.name.message}
                      </p>}
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer text-end">
              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default EditMedicineComposition;
